import { ConversationPage } from '@pages/ConversationPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/conversation/$id')({
  component: ConversationPage,
})
